import { useNavigate, useParams } from 'react-router-dom';
import { useContext } from 'react';
import { NUMERIC_RE, SLUG_ID_RE, ROOMS_RE } from '../lib/urls';
import Error from '../pages/Error';
import initialDataContext from '../contexts/initialDataContext';

// Resolves all routes of one listing category:
//   /C                      -> list, all locations
//   /C/chirie               -> list, chirie, all locations
//   /C/:loc                 -> list by location slug (vânzare implicit)
//   /C/:loc/chirie          -> list by location slug, chirie
//   /C/:loc/:sector         -> list by location + sector (Chișinău)
//   /C/:loc/:sector/chirie  -> list by location + sector, chirie
//   /C/:loc/:slug-<id>      -> detail page (slug always ends with -<id>)
//   /C/123                  -> legacy numeric detail
//   /C/:loc/vanzare         -> legacy 3-segment URL -> redirect
export default function CategoryRoute({ page: Page, detail: Detail, base, chirieSuffix = false }) {
  const { location: loc, param } = useParams();
  const navigate = useNavigate();
  const saleType = chirieSuffix ? 2 : 1;

  // SSR flagged an invalid location/sector slug -> serve the 404 page.
  const ssrData = useContext(initialDataContext);
  if (ssrData?.type === 'notfound' || loc === 'undefined' || param === 'undefined') {
    return <Error />;
  }

  if (loc === undefined) {
    if (param === undefined) {
      return <Page locationSlug="" sectorSlug="" saleType={saleType} saleTypeInPath={chirieSuffix} />;
    }
    if (NUMERIC_RE.test(param)) {
      return <Detail />;
    }
    if (param === 'chirie') {
      return <Page locationSlug="" sectorSlug="" saleType={2} saleTypeInPath />;
    }
    if (param === 'vanzare') {
      navigate(`/${base}`, { replace: true });
      return null;
    }
    return <Page locationSlug={param} sectorSlug="" saleType={1} saleTypeInPath={false} />;
  }

  if (param === undefined) {
    return <Page locationSlug={loc} sectorSlug="" saleType={saleType} saleTypeInPath={chirieSuffix} />;
  }
  if (base === 'apartamente' && ROOMS_RE.test(param)) {
    const rooms = parseInt(param, 10);
    return <Page
      locationSlug={loc}
      sectorSlug=""
      saleType={saleType}
      saleTypeInPath={chirieSuffix}
      roomsFilter={{ min: rooms, max: rooms < 4 ? rooms : undefined }}
    />;
  }
  if (SLUG_ID_RE.test(param)) {
    if (chirieSuffix) {
      navigate(`/${base}/${loc}/${param}`, { replace: true });
      return null;
    }
    return <Detail />;
  }
  if (param === 'vanzare') {
    navigate(`/${base}/${loc}`, { replace: true });
    return null;
  }
  return <Page locationSlug={loc} sectorSlug={param} saleType={saleType} saleTypeInPath={chirieSuffix} />;
}
